import {
  PlannerItemHeroIconSize,
  ShadowPulse
} from '@cont/PlannerV2/PlannerCards/ClassCard/PlayIcon';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import TestHeroCircle from '@icon/Planner/TestHeroCircle';

const StyledIcon = styled(TestHeroCircle)`
  border-radius: 50%;
  ${({ $isLive }) =>
    $isLive &&
    css`
      animation: ${ShadowPulse} 1s infinite;
    `}
`;

const TestHeroIcon = ({ color, isLive }) => (
  <StyledIcon
    size={PlannerItemHeroIconSize}
    data-testid="planner-test-icon"
    className="play-icon"
    color={color}
    $isLive={isLive}
  />
);

export default TestHeroIcon;
